import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpUrlEncodingCodec, HttpParams } from '@angular/common/http';
import { OepaIopAuthLibService } from '@ohioepa/oepa-iop-auth-lib';
import { catchError } from 'rxjs/operators';
import { GWQCService } from '../app/gwqcp/gwqcp/gwqcp.service';
@Injectable({
    providedIn: 'root'
})
export class JWTHttpInterceptor implements HttpInterceptor {

    constructor(private authService: OepaIopAuthLibService, private gwqcService: GWQCService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let handleReq = req;

    // Skip adding Authorization header for S3 pre-signed URLs
    if (!req.url.includes('amazonaws.com')) {
      const token = this.authService.getAccessToken();
      let headers = req.headers.set('Authorization', 'Bearer ' + token);
      const currentUserOHID = this.gwqcService.getCurrentUserOHID();
      
      if (currentUserOHID) {
        headers = headers.set('User-Id', currentUserOHID);
      }
      
      handleReq = req.clone({ headers });
    }

    return next.handle(handleReq).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('HTTP Error:', error);

        if (error.status === 404) {
          console.warn(`404 Not Found: ${error.url}`);
          return throwError(() => error);
        }

        // Dynamically extract the true error message
        const errorMessage = this.extractErrorMessage(error);
        this.openSnackBar(errorMessage, 'Close');

        return throwError(() => error);
      })
    );
  }

  /**
   * Safely extracts the error message across string, JSON, and standard HTTP responses.
   */
  private extractErrorMessage(error: HttpErrorResponse): string {
    // 1. If error.error is a primitive string (e.g., plain text response or raw JSON string)
    if (typeof error.error === 'string') {
      try {
        const parsed = JSON.parse(error.error);
        return parsed.message || parsed.Message || parsed.detail || parsed.error || error.error;
      } catch {
        return error.error; // Plain string error message
      }
    }

    // 2. If error.error is a JSON object
    if (error.error && typeof error.error === 'object') {
      return (
        error.error.message ||
        error.error.Message || // Common in C# / AWS S3
        error.error.detail ||
        error.error.error ||   // Common in Express / OAuth responses
        error.error.title ||   // Common in ASP.NET problem details
        error.error.msg
      );
    }

    // 3. Fallback to HttpErrorResponse statusText or Angular's default message
    return error.statusText || error.message || 'An unexpected error occurred.';
  }

  private openSnackBar(message: string, action: string) {
    this.gwqcService.openSnackBar(message, action, 'error');
  }
}
